import { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface WorkshopContextType {
  selectedWorkshop: string;
  setSelectedWorkshop: (id: string) => void;
}

const WorkshopContext = createContext<WorkshopContextType | undefined>(undefined);

export const WorkshopProvider = ({ children }: { children: ReactNode }) => {
  const [selectedWorkshop, setSelectedWorkshopState] = useState<string>("");

  useEffect(() => {
    // Load from localStorage on mount
    const saved = localStorage.getItem("selectedWorkshopId");
    if (saved) {
      setSelectedWorkshopState(saved);
    }
  }, []);

  const setSelectedWorkshop = (id: string) => {
    setSelectedWorkshopState(id);
    localStorage.setItem("selectedWorkshopId", id);
  };

  return (
    <WorkshopContext.Provider value={{ selectedWorkshop, setSelectedWorkshop }}>
      {children}
    </WorkshopContext.Provider>
  );
};

export const useWorkshop = () => {
  const context = useContext(WorkshopContext);
  if (context === undefined) {
    throw new Error("useWorkshop must be used within a WorkshopProvider");
  }
  return context;
};
